//Accordion
var list = document.getElementsByClassName("faq--question");
for (var i = 0; i < list.length; i++) {
    var faqQuestion = document.getElementsByClassName("faq--question")[i];
    faqQuestion.onclick = function() {
      console.log('clicci');
      this.parentElement.classList.toggle('active');
    };
}





